import { Input } from '../inputs/Input.mjs';
import WithDisplayFormat from '../withDisplayFormat/WithDisplayFormat.mjs';
import { jsx } from 'react/jsx-runtime';

const InputWithDisplayFormat = props => /*#__PURE__*/jsx(WithDisplayFormat, {
  ...props,
  render: renderProps => /*#__PURE__*/jsx(Input, {
    ...renderProps
  })
});

export { InputWithDisplayFormat as default };
//# sourceMappingURL=InputWithDisplayFormat.mjs.map
